import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectAccount } from '../../../features/auth/ducks';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { apiCallIds } from '../../../features/auth/api';
import { updateAccountProfileActions } from '../../../features/auth/ducks';
import UserProfile from '../components/UserProfile';

const mapStateToProps = state => ({
  account: selectAccount(state),
  isUpdating: selectIsInProgress(state, apiCallIds.UPDATE_ACCOUNT_PROFILE),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateAccountProfile: updateAccountProfileActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class UserProfileContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    account: PropTypes.object.isRequired,
    isUpdating: PropTypes.bool.isRequired,
  };

  onSubmit = profileData => {
    const { actions, account } = this.props;
    actions.updateAccountProfile({
      accountId: account.id,
      profileData,
      redirect: '/dashboard',
    });
  };

  render() {
    return (
      <UserProfile
        isUpdating={this.props.isUpdating}
        account={this.props.account}
        onSubmit={this.onSubmit}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/user-profile/containers/UserProfileContainer.js